import {all, fork, put, takeLatest} from 'redux-saga/effects';
import {
  getAllUnreadNotificationsSuccess,
  getLastNotificationsSuccess,
  getNotificationsSuccess,
  getNotificationSuccess,
  getUnreadNotificationsSuccess,
} from 'redux/actions';
import {
  NOTIFICATIONS_ALL,
  NOTIFICATIONS_ALL_UNREAD,
  NOTIFICATIONS_GET,
  NOTIFICATIONS_LAST,
  NOTIFICATIONS_UNREAD,
} from 'redux/constants/Notifications';
import EstService from 'services/EstService';

export function* getNotifications() {
  yield takeLatest(NOTIFICATIONS_ALL, function* ({ perPage, page }) {
    try {
      const res = yield EstService.getNotifications(perPage, page);
      const skip = perPage * (page - 1);
      const from = skip + 1;
      const to = skip + perPage > res.total ? res.total : skip + perPage;
      yield put(getNotificationsSuccess(res.data, res.total, from, to));
    } catch (err) {
      console.log(err);
    }
  });
}

export function* getNotification() {
  yield takeLatest(NOTIFICATIONS_GET, function* ({ id }) {
    try {
      const res = yield EstService.getNotification(id);
      yield put(getNotificationSuccess(res.data));
    } catch (err) {
      console.log(err);
    }
  });
}

export function* getUnreadNotifications() {
  yield takeLatest(NOTIFICATIONS_UNREAD, function* () {
    try {
      const res = yield EstService.getUnreadCount();
      if (res && res.data) {
        yield put(getUnreadNotificationsSuccess(res.data.total_unread));
      }
    } catch (err) {
      console.log(err);
    }
  });
}

export function* getAllUnreadNotifications() {
  yield takeLatest(NOTIFICATIONS_ALL_UNREAD, function* () {
    try {
      const { data } = yield EstService.getUnreadCount();
      const res = yield EstService.getUnreadNotifications(data.total_unread);
      if (res && res.data) {
        yield put(getAllUnreadNotificationsSuccess(res.data));
      }
    } catch (err) {
      console.log(err);
    }
  });
}

export function* getLastNotifications() {
  yield takeLatest(NOTIFICATIONS_LAST, function* ({ count }) {
    try {
      const res = yield EstService.getNotifications(count, 1, true);
      if (res && res.total) {
        const total = res.total;
        // Last page works, no remainder even when we don't have enough notifications to match count
        if (total % count === 0) {
          const lastPage = yield EstService.getNotifications(
            count,
            res.last_page
          );
          yield put(getLastNotificationsSuccess(lastPage.data));
        } else {
          // If we have remainder, request for the last page and multiply count * 2
          const lastPageNumber = Math.ceil(total / (count * 2));
          const lastPage = yield EstService.getNotifications(
            count * 2,
            lastPageNumber,
            true
          );
          yield put(
            getLastNotificationsSuccess(lastPage.data.slice(-1 * count))
          );
        }
      }
    } catch (err) {
      console.log(err);
    }
  });
}

export default function* notificationsSaga() {
  yield all([
    fork(getNotifications),
    fork(getNotification),
    fork(getUnreadNotifications),
    fork(getAllUnreadNotifications),
    fork(getLastNotifications),
  ]);
}
